<template>
  <div>
    <template>
      <v-divider></v-divider>
      <CheckoutSummary
        :screener="screener"
        :pricing="pricing"
        :seats="seats"
        :event_type="event_type"
        :currency="company.currency"
        :price="price"
        :applied_coupon="applied_coupon"
      ></CheckoutSummary>
      <v-divider
        v-if="
          pricing &&
            pricing.type == DEFINES.MONETIZATION.PRICING_TYPE.GROUP_PURCHASE
        "
      ></v-divider>
      <!-- Showing screener list in case of pass purchase -->
      <ListScreenersInPass
        v-if="
          pricing &&
            pricing.type == DEFINES.MONETIZATION.PRICING_TYPE.GROUP_PURCHASE
        "
        :eventPrefix="eventPrefix"
        :pricing="pricing"
        :screener="screener"
      ></ListScreenersInPass>
      <v-divider></v-divider>
    </template>
    <div class="px-4 mt-3" v-if="price">
      <!-- Ask to redeem coupon in if any in case of virtual events-->
      <CouponForm
        v-if="event_type <= DEFINES.SCREENER_TYPE_VALUE.VIRTUAL"
        ref="couponFormComp"
        :having_coupon.sync="having_coupon"
        :coupon_code.sync="coupon_code"
        @redeem="redeemCoupon"
      ></CouponForm>

      <PaymentGateway
        :event_type="event_type"
        :screener_id="screener ? screener.id : null"
        :pricing_id="pricing ? pricing.id : null"
        :company="company"
        :coupon_code="coupon_code"
        :eventPrefix="eventPrefix"
        :applied_coupon="applied_coupon"
        :price="price"
        :having_coupon="having_coupon"
        @success="success"
        @failed="failed"
        @reset="reset"
      ></PaymentGateway>
    </div>

    <v-card-actions class="px-4 pb-4">
      <slot name="back-button"></slot>
      <v-spacer></v-spacer>
      <v-btn
        color="primary background--text"
        :class="[$vuetify.rtl ? 'ml-2' : '', 'white--text']"
        @click.stop="reset"
        flat
        >{{ $t('screener.btn.cancel') }}</v-btn
      >
      <!-- Show Participate for 100% discount only -->
      <v-btn
        v-if="(having_coupon && applied_coupon.discount_percentage == 100) || price==0"
        color="primary background--text"
        :class="[$vuetify.rtl ? 'mx-0' : '', 'white--text']"
        @click.stop="participate"
        :loading="loading"
        :disabled="loading"
        >{{ $t(`${eventPrefix}.btn.participate`) }}</v-btn
      >
    </v-card-actions>
  </div>
</template>

<script>
import ListScreenersInPass from '@/components/monetization/ListScreeners';
import CouponForm from '@/components/monetization/CouponForm';
import CheckoutSummary from '@/components/monetization/CheckoutSummary';
import {mapState} from 'vuex';
import {EventBus} from '@/event-bus.js';
import PaymentGateway from '@/components/paymentGateway/PaymentGateway';
import {paymentActionClassifier} from '@/mixins/monetization.js';
import {mapFields} from "vuex-map-fields"

export default {
  name: 'EnrollmentPaymentCheckout',
  props: {
    eventPrefix: {
      type: String,
      default: 'screener',
    },
    pricing: {
      type: Object,
      default: null,
    },
    screener: {
      type: Object,
      default: null,
    },
    seats: {
      type: Array,
      default: function() {
        return [];
      },
    },
    event_type: {
      default: function() {
        return this.DEFINES.SCREENER_TYPE_VALUE.VIRTUAL;
      },
    },
  },
  data() {
    return {
      having_coupon: false,
      coupon_code: null,
      applied_coupon: {
        applicable: false,
        available_discount: 0,
        discount_percentage: 0,
      },
      loading: false,
    };
  },
  components: {
    ListScreenersInPass,
    CouponForm,
    CheckoutSummary,
    PaymentGateway,
  },
  mixins: [paymentActionClassifier],
  computed: {
    ...mapState({
      company: (state) => state.company.company,
    }),
    ...mapFields("consumer", {
          consumer_uuid: "uuid",
    }),
    price() {
      var price = 0;
      // Price of pricing plan
      if (this.pricing) {
        price = this.pricing.price;
      }
      // Total price of seats
      if (this.seats.length) {
        price = this.seats.reduce(
          (total, seat) => total + parseFloat(this._calculateSeatPrice(seat)),
          0
        );
      }
      return price - this.applied_coupon.available_discount;
    },
  },
  created() {
    let _this = this;
    EventBus.$on('setCouponPayload', function(couponPayload) {
      _this.applied_coupon = couponPayload.applied_coupon;
      _this.coupon_code = couponPayload.coupon_code;
      _this.having_coupon = couponPayload.having_coupon;
    });
  },
  methods: {
    _calculateSeatPrice(seat) {
      let discounts = {};
      if (this.screener.physical_venue_ticket_types_discount) {
        discounts = this.screener.physical_venue_ticket_types_discount;
      }
      if (!seat.ticket_type || !discounts.hasOwnProperty(seat.ticket_type)) {
        return seat.price?seat.price:0;
      }
      let discount = seat.price * (discounts[seat.ticket_type] / 100);
      let price = seat.price - discount;
      return price.toFixed(2);
    },

    success(response = {}) {
      // Tracking purchase at FBQ
      this._fbqTrackPurchase(response);
      this.$emit('onSuccess', response);
    },
    failed(error = {}) {
      this.$emit('onFailed', error);
    },
    reset() {
      this.$emit('onReset');
      if (this.$refs.couponFormComp) {
        this.$refs.couponFormComp.reset();
      }
      this.resetCoupon();
    },
    _getPurchaseTypeLabel(purchase_type) {
      switch (purchase_type) {
        case this.DEFINES.MONETIZATION.PRICING_TYPE.SINGLE_PURCHASE:
          return this.$t('screener.purchase_type.single.title');
        case this.DEFINES.MONETIZATION.PRICING_TYPE.GROUP_PURCHASE:
          return this.$t('screener.purchase_type.pass.title');
        case this.DEFINES.MONETIZATION.PRICING_TYPE.VOD_PURCHASE:
          return this.$t('screener.purchase_type.vod.title');
        case this.DEFINES.MONETIZATION.PRICING_TYPE.PHYSICAL_TICKET_PURCHASE:
          return this.$t('screener.purchase_type.physical_event.title');
        default:
          return this.$t('screener.purchase_type.default.title');
      }
    },
    async _fbqTrackPurchase(response) {
      try {
        if (!this.company.custom_properties.fbpixelId) {
          return;
        }
        const payload = {
          currency: response.purchase.currency,
          value: response.purchase.total_amount,
          content_type: this._getPurchaseTypeLabel(
            response.purchase.purchase_type
          ),
          content_ids: response.purchase.pricing
            ? response.purchase.pricing.screening_ids
            : response.purchase.booking_id,
          content_name: response.purchase.pricing
            ? response.purchase.pricing.name
            : this.$t('screener.ticket_bookings.title'),
        };
        await fbq('track', response.purchase.status == this.DEFINES.PURCHASE_STATUS['COMPLETED']?'Purchase':'in-process', payload);
      } catch (error) {
        this.$store.dispatch('app/showMessage', {
          message: error.message,
          color: 'error',
        });
      }
    },
    async redeemCoupon() {
      if (!this.$refs.couponFormComp.validate()) {
        return false;
      }
      try {
        var response = await this.$store.dispatch('consumer/redeemCoupon', {
          pricing_id: this.pricing ? this.pricing.id : null,
          coupon_code: this.coupon_code,
          company_id: this.company.id,
        });
        this.applied_coupon.applicable = true;
        this.applied_coupon.available_discount =
          this.price * (response.discount / 100);
        this.applied_coupon.discount_percentage = response.discount;
      } catch (error) {
        this.$store.dispatch('app/showMessage', {
          message: error.message,
          color: 'error',
        });
      }
    },
    resetCoupon() {
      this.having_coupon = false;
      this.coupon_code = null;
      this.applied_coupon = {
        applicable: false,
        available_discount: 0,
        discount_percentage: 0,
      };
    },
    async participate(){
        this.loading = true;
        const payload = {};
        const action = this._moduleWithAction();

        switch (this.event_type) {
                case this.DEFINES.SCREENER_TYPE_VALUE.VIRTUAL:
                    payload.pricing_id = this.pricing.id;
                    break;
                case this.DEFINES.SCREENER_TYPE_VALUE.PHYSICAL:
                    payload.screener_id = this.screener.id;
                    break;
                default:
                    break;
        }
        payload.token = null;
        payload.zip_code = null;
        payload.address = null;
        payload.coupon_code = this.coupon_code;
        payload.charge_type ="stripe"; //TODO: why stripe?
        payload.consumer_uuid = this.consumer_uuid;


        try {
            let response = await this.$store.dispatch(action, payload);
            this.success(response);
        }catch (error) {
            this.failed(error);
            this.$store.dispatch("app/showMessage", {
                message: error.message,
                color: "error",
            });
        }finally{
            this.loading = false;
            this.reset();
        }
    }
  },
};
</script>

<style></style>
